module.exports = __webpack_public_path__ + "static/itsm_capabilities_8-faef0a67e452a3e583262ea70fd30a8c.png";